/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('store.mypage.table', function (el) {
        var table = new MypageTable(el);
        table.init();
    });
    var MypageTable = /** @class */ (function () {
        function MypageTable(el) {
            this.el = el;
        }
        MypageTable.prototype.init = function () {
            var _this = this;
            util.delegate(this.el, 'change', '.datepicker', function (e) {
                var el = e.target;
                if (!el.classList.contains('selecting')) {
                    _this.updateData();
                }
            });
        };
        MypageTable.prototype.updateData = function () {
            var filterRangeValues = this.getActiveSelectRangeValues();
            var selectedParams = Object.assign({}, filterRangeValues);
            var queryString = Object.entries(selectedParams).map(function (e) { return e.join('='); }).join('&');
            var url = new URL(this.el.action + queryString);
            var newUrl = url.href;
            if (newUrl !== window.location.href) {
                window.location.href = newUrl;
            }
        };
        MypageTable.prototype.getActiveSelectRangeValues = function () {
            var values = {};
            this.el.querySelectorAll('.datepicker').forEach(function (el) {
                if (el instanceof HTMLInputElement && el.classList.contains('datepicker')) {
                    var value = el.value;
                    var from = el.getAttribute('data-from');
                    var to = el.getAttribute('data-to');
                    var elm = el.id;
                    if (value && from && to) {
                        values[elm] = value;
                    }
                    else {
                        var defaultDate = el.dataset['defaultDate'];
                        if (defaultDate) {
                            values[elm] = defaultDate.replace(' ', ' to ');
                        }
                    }
                }
            });
            return values;
        };
        return MypageTable;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
